<template>
  <b-modal
    id="people-text-question-list-modal"
    size="xl"
    centered
    hide-footer
  >
    <b-row>
      <b-col
        v-for="(contentItem, index) in contents"
        :key="index"
        cols="12"
        md="6"
        lg="4"
        @click="handleShowLongAnswer(contentItem)"
      >
        <b-card border-variant="secondary">
          <template #header>
            <b-media no-body>
              <b-media-aside>
                <b-avatar
                  variant="light-primary"
                  :text="getInitials(contentItem.user.fullName)"
                />
              </b-media-aside>
              <b-media-body class="text-capitalize">
                <h6 class="transaction-title">
                  {{ contentItem.user.fullName }}
                </h6>
                <small>{{ contentItem.user.role }}</small>
              </b-media-body>
            </b-media>
          </template>
          <b-card-text>{{ contentItem.label }}</b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <long-answer :content="content" />
  </b-modal>
</template>

<script>
import {
  BCard, BCardText, BModal, BRow, BCol, /* BPagination, */ BMedia, BMediaAside, BAvatar, BMediaBody,
  VBModal,
} from 'bootstrap-vue'
import { getInitials } from '@hw-core/utils'
import LongAnswer from './LongAnswer.vue'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BCard,
    BCardText,
    BModal,
    BRow,
    BCol,
    // BPagination,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    LongAnswer,
  },
  props: {
    contents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      perPage: 9,
      currentPage: 1,
      content: null,
    }
  },
  methods: {
    getInitials,
    handleShowLongAnswer(content) {
      this.content = content
      this.$bvModal.show('long-answer-modal')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep div {
  .modal-dialog.modal-dialog-centered {
    justify-content: center;
  }
}
</style>
